import {
    Box,
    BoxProps,
    Tab,
    TabList,
    Tabs,
    useMediaQuery,
    useColorMode,
    Flex,
    Image,
    TabPanel,
    TabPanels,
    Text,
    VStack
} from "@chakra-ui/react";
import SearchBar from "./SearchBar";
import MobileHeader from "../layout/MobileHeader";
import {ReactNode, useEffect, useState} from "react";
import {scrollbar} from "../styling";

interface HeaderProps {
    title: string;
    currentTab?: number;
    searchbarWidth?: string;
    searchPlaceHolder?: string,
    showCloserHeader?: boolean;
    isEventHistory?: boolean;
    searchBg?: string
    tabs?: string[];
    onSearch?: (searchTerm: string) => void;
    onTabChange?: (tabViewIndex: number) => void;
    onFilterClick?: () => void;
    onNavHeaderClick?: () => void;
}
type BarsProps = {
    tabs: [label: string, content: ReactNode][]
    initialTab?: number
    onTabChange?: (v: number) => void
}
export function SystemTab(prop: {name: string}) {
    return <Tab
        _selected={{
            borderBottomWidth: "3px",
            borderBottomColor: "primary.500",
            color: "primary.500",
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "18px",
        }}
        fontWeight="500"
        fontSize="14px"
        lineHeight="18px"
        color="dark.100"
        p=".5rem 1rem"
        style={{textWrap: "nowrap"}}
    >
        {prop.name}
    </Tab>;
}

export function MultipleTabs(props: BarsProps) {
    const [tab, setTab] = useState(props.initialTab ?? 0);
    useEffect(function () {
        if (props.onTabChange) {
            props.onTabChange(tab);
        }
    }, [tab]);
    return <Tabs
        display="flex"
        flexDir="column"
        justifyContent={{
            base: "center",
            md: "start",
            lg: "start",
        }}
        onChange={(i) => setTab(i)}
        index={tab}
        border="none"
        variant={"unstyled"}
        bg="transparent"
        pt={4}
        flex="2 1 auto"
    >
        <TabList maxWidth="99%" overflowX="auto" gap=".5rem" sx={scrollbar.hidden} pb={0} position="sticky" insetY="0px" bg="white" zIndex="overlay">
            {props.tabs.map(([label], idx) => (
                <SystemTab key={idx} name={label}/>
            ))}
        </TabList>
        <TabPanels>
            {props.tabs.map(([_, content], idx) => (
                <TabPanel
                    key={idx}
                    display="flex"
                    gap="1rem"
                    flexDir="column"
                    p={{base: ".5rem 0", md: "1rem 0"}}
                    minH={{base: "min(650px, 70dvb)", md: "min(650px, 80dvb)"}}
                    maxH="80lvb"
                >
                    {content}
                </TabPanel>
            ))}
        </TabPanels>
    </Tabs>;
}


function HeaderComponent(props: HeaderProps & BoxProps) {
    const {colorMode} = useColorMode();
    const [isSmallScreen] = useMediaQuery("(max-width: 767px)");
    const displayTabView = Number.isFinite(props.currentTab) && props.onTabChange;
    const tabs = props.tabs ?? ["List View", "Map View"];
    return <VStack
        bg={props.bg ?? "white"}
        h={props.height ?? {base: "fit-content", md: "auto"}}
        w="full"
        borderRadius={{md: "0px 0px 24px 24px", lg: "0px 0px 24px 24px"}}
        boxShadow={props.boxShadow ?? {
            md:
            colorMode === "light"
                ? "0px 2px 8px -1px rgba(27, 36, 44, 0.12)"
                : "0px 2px 8px -1px grey",
        }}
        px={props.px ?? props.paddingX ?? "16px"}
        pt={props.pt ?? {base: "1rem", md: "24px"}}
        pb={props.pb ?? {base: displayTabView ? "16px" : "24px", md: "16px"}}
        align="start"
        gap="1rem"
    >
        {isSmallScreen && (
            <MobileHeader
                title={props.title}
                pl={props.px !== "0" ? "0": "16px"}
                isBackButton={!!props.onNavHeaderClick}
                onClick={props.onNavHeaderClick}
                bg={props.bg ?? "white"}
            />
        )}

        {props.showCloserHeader && !isSmallScreen && (
            <Flex
                alignItems="center"
                gap="8px"
                w="full"
                bgColor="#F5F7F9"
                _hover={{ cursor: "pointer" }}
                onClick={props.onNavHeaderClick}
            >
                <Image
                    src={"/images/chevron-left.svg"}
                    _hover={{ cursor: "pointer" }}
                    onClick={props.onNavHeaderClick}
                />
                <Text
                    fontWeight={500}
                    lineHeight="22px"
                    color="dark.500"
                    fontSize="18px"
                >
                    {props.title}
                </Text>
            </Flex>
        )}
        {props.onSearch && <SearchBar
            onFilterClick={props.onFilterClick}
            onSearch={props.onSearch}
            placeholder={props.searchPlaceHolder}
            searchBarWidth={props.searchbarWidth}
            localSearch
            bg={props.searchBg ?? "#F5F7F9"}
            isEventHistory={!!props.isEventHistory}
        />}
        {!!displayTabView && (
            <Tabs
                position="relative"
                display={"flex"}
                onChange={props.onTabChange}
                index={props.currentTab}
                border="none"
                ml={{base: 0, md: 2}}
                variant={"unstyled"}
                bg="transparent"
                alignSelf="stretch"
            >
                <TabList maxWidth="99%" overflowX="auto" gap=".5rem" sx={scrollbar.hidden} pb={0}>
                    {
                        tabs.map(function(val, i) {
                            return <SystemTab key={i} name={val}/>;
                        })
                    }
                </TabList>
            </Tabs>
        )}
    </VStack>;
}

export default HeaderComponent;
